CustomFieldItem = require 'models/custom-field-item'
Dates = require 'lib/dates'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
template = require 'views/templates/date_editor'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
moment = require 'moment'
Pikaday = require 'pikaday'
l = require 'lib/localize'
ClientConfig = require 'debug/client-config'

getPikadayStrings = ->
  previousMonth: l('prev month button text')
  nextMonth: l('next month button text')
  months: moment.months()
  weekdays: moment.weekdays()
  weekdaysShort: moment.weekdaysMin()

timeFormat = 'LT'
parseFormat = [timeFormat, 'h:mm A']
isTimeStringValid = (string) -> moment(string, parseFormat).isValid()

module.exports = class DateEditorView extends View
  viewTitleKey: 'edit date'
  tagName: 'form'
  className: 'dpicker-widget u-clearfix'

  viewTitleArguments: ->
    fieldName: @options.customField.get('name')

  events:
    'click .js-remove-date': 'removeDueDate'
    'input .js-dpicker-time-input': 'validateTimeInput'
    'change .js-dpicker-time-input': 'normalizeTimeInput'
    'submit': (e) ->
      e.preventDefault()
      @submitDueDate()


  getSelectedDueDateMoment: ->
    date = @picker.getMoment()
    if !date.isValid()
      return null

    # Pikaday requires a single date format, and will parse it strictly (which
    # is good). However, this means an entry like '2/14/15' will parse as
    # '02/14/0015', which isn't great.
    if date.year() < 1000
      date.add(2000, 'years')

    time = @selectedTimeMoment()
    date
    .hour time.hour()
    .minute time.minute()

  submitDueDate: ->
    dueDateMoment = @getSelectedDueDateMoment()
    if dueDateMoment?
      @setDueDate dueDateMoment.toDate()
    else
      @removeDueDate()

  setDueDate: (date) ->
    DateEditorView.lastDueDate = date
    if @options.customFieldItem?
      @options.customFieldItem.setValue({ date: date.toISOString() })
    else
      @model.customFieldItemList.create({
        idCustomField: @options.customField.id
        idModel: @model.id
        modelType: 'card'
        value:
          date: date.toISOString()
      })
    PopOver.hide()

  removeDueDate: ->
    if @options.customFieldItem
      @options.customFieldItem.clearValue()
    PopOver.hide()

  vigor: @VIGOR.NONE
  renderOnce: ->
    customFieldItem = @options.customFieldItem?.toJSON()
    tomorrowAtNoon = moment().startOf('day').add(1, 'days').hour(12).toDate()
    dueDate = customFieldItem?.value?.date ? DateEditorView.lastDueDate ? tomorrowAtNoon

    @$el.html template({ canRemove: customFieldItem? })

    @picker = new Pikaday
      field: @$('.js-dpicker-date-input')[0]
      container: @$('.js-dpicker-cal')[0]
      bound: false
      format: 'l'
      firstDay: moment.localeData().firstDayOfWeek()
      i18n: getPikadayStrings()
    @picker.setDate dueDate

    @$timeInput().val moment(dueDate).format(timeFormat)

    @

  validateTimeInput: ->
    @$timeInput().toggleClass 'input-error', !@isTimeInputValid()

  normalizeTimeInput: ->
    @$timeInput().val @selectedTimeMoment().format(timeFormat)
    @validateTimeInput()

  selectedTimeMoment: ->
    if @isTimeInputValid()
      moment(@$timeInput().val(), parseFormat)
    else
      moment().hours(12).minutes(0)

  $timeInput: -> @$('.js-dpicker-time-input')

  isTimeInputValid: -> isTimeStringValid @$timeInput().val()



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/date-editor-view.coffee